import { render, staticRenderFns } from "./useTheIndex.vue?vue&type=template&id=e5e2ef4c"
import script from "./useTheIndex.vue?vue&type=script&lang=js"
export * from "./useTheIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports